export function Option({ value, title }) {
  return <option value={value}>{title}</option>;
}
